import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Sidebar } from 'primeng/sidebar';
import { StorageService } from '../../services/storage.service';
import { Router } from '@angular/router';
import { AuthUser } from '../../shared/interface';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-struttura-backoffice',
  templateUrl: './struttura-backoffice.component.html',
  styleUrl: './struttura-backoffice.component.css'
})
export class StrutturaBackofficeComponent implements OnInit, OnDestroy {

  constructor(private apiService: ApiService, private storageService: StorageService, private router: Router) { }

  sidebar: boolean = false;
  password: boolean = false;

  user?: AuthUser | null;

  formPassword!: FormGroup;

  @ViewChild('sidebarRef') sidebarRef!: Sidebar;

  ngOnInit(): void {
    document.documentElement.classList.add('bo-scroll-lock');
    this.user = this.storageService.getUser();

    this.formPassword = new FormGroup({
      password: new FormControl(null, [Validators.required, Validators.minLength(4)]),
      confirm_password: new FormControl(null, [Validators.required, Validators.minLength(4)]),
    },
      {
        validators: this.passwordMatchValidator
      }
    )
  }

  ngOnDestroy(): void {
    document.documentElement.classList.remove('bo-scroll-lock');
  }

  passwordMatchValidator(control: AbstractControl) {
    return control.get('password')?.value === control.get('confirm_password')?.value ? null : { mismatch: true }
  }

  closeCallback(e: any): void {
    this.sidebarRef.close(e);
  }

  onLogOut() {
    this.storageService.clearStorage();
    this.router.navigate(['/backoffice/login'])
  }

  onPassword() {
    const credenziali = {
      password: this.formPassword.get('password')?.value || '',
      confirm_password: this.formPassword.get('confirm_password')?.value || ''
    }

    if (credenziali.password.length > 0) {

      this.apiService.updatePasswordUtente(credenziali.password, this.user!.id).subscribe({        
        error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
        complete: () => this.apiService.message('success', 'Modifica', "Modifica effettuata con successo!")        
      })

    } else {      
      this.apiService.message('error', 'Errore', "Inserire la password per procedere!")
    }
  }

}
